module.exports = __webpack_public_path__ + "img/header_home.bd696455.png";